{
  "certificates": {
    "kpiConnector": "Connecteur KPI",
    "trustore": "Truststore",
    "s4Device": "Équipements S4",
    "s4ToolsApp": "Applicatifs S4-Tools",
    "s4ManagerApp": "Applicatifs S4-Manager",
    "s4ViewApp": "Applicatifs S4-View",
    "sg4000": "Applicatifs SG4000",
    "requiredFields": "Les champs précédés d'un * sont obligatoires.",
    "delayInfo": "Le délai de renouvellement automatique définit le délai avant la date d'expiration du certificat à partir duquel le lancement automatique de la procédure de renouvellement du certificat est enclenché.",
    "delayPlaceholder": "Délai de renouvellement automatique",
    "delayPlaceholderCustom": "Délai de renouvellement automatique (en jours)",
    "pollingPlaceholder": "Fréquence de polling (minutes)",
    "pollingInfoDevice": "La fréquence de polling correspond au délai entre 2 échanges entre LX CONNECT et l'équipement.",
    "pollingInfoApplication": "La fréquence de polling correspond au délai entre 2 échanges entre LX CONNECT et l'applicatif.",
    "autoActivationLabel": "Activation automatique",
    "autoActivationAction": "Activer",
    "autoActivationInfoApplication": "L'activation automatique permet d'activer l'application au moment de l'approvisionnement.",
    "autoActivationInfoDevice": "L'activation automatique permet d'activer l'équipement au moment de l'approvisionnement.",
    "title": "Certificats"
  },
  "firmware": {
    "title": "Firmware",
    "firmwareManagement": "Gestion des firmwares"
  },
  "users": {
    "title": "Utilisateurs",
    "activeDirectory": "Active Directory"
  },
  "application": {
    "title": "Configuration de l'applicatif",
    "smtpServor": "Serveur SMTP",
    "feelAndIdentity": "Aspect et identité"
  },
  "applicationMgt": {
    "title": "Applications",
    "applicationManagement": "Gestion des applications"
  },
  "usersPreference": {
    "title": "Préférences de l'utilisateur",
    "userParams": "Paramètres utilisateur"
  },
  "technicalVersion": {
    "label": "Version technique :",
    "unknown": "inconnue"
  },
  "version": {
    "label": "Version :",
    "unknown": "inconnue"
  },
  "platformMgt": {
    "title": "Plateforme",
    "about": "A propos"
  },
  "deviceConfiguration": "Configuration des équipements"
}
